<template>
  <v-dialog v-model="dialog" max-width="1400px" persistent>
    <v-card class="setting-modal-card">
      <v-card-title class="setting-modal-header">
        <div class="d-flex align-center">
          <v-avatar class="rounded-lg mr-3" color="#2B4A6F" size="40">
            <v-icon color="white" size="22">mdi-cog-outline</v-icon>
          </v-avatar>
          <div>
            <div class="text-h6 font-weight-bold color-navy">Setting</div>
            <div class="text-caption grey--text text--darken-1">
              Manage Organization, Account & Topic
            </div>
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-tabs
        v-model="activeTab"
        class="setting-tabs"
        color="#0471A5"
        grow
      >
        <v-tab>
          <v-icon left>mdi-pin</v-icon>
           Account & Organization
        </v-tab>
        <v-tab>
          <v-icon left>mdi-earth</v-icon>
          Group Analysis Management
        </v-tab>
        <v-tab>
          <v-icon left>mdi-notebook-outline</v-icon>
          Keyword & Slogan
        </v-tab>
      </v-tabs>

      <v-card-text class="setting-modal-body">
        <div class="setting-content">
          <div v-if="tabLoading" class="setting-loader">
            <v-progress-circular
              indeterminate
              color="#0471A5"
              size="50"
            ></v-progress-circular>
            <div class="setting-loader-text">Loading...</div>
          </div>
          <v-tabs-items v-show="!tabLoading" v-model="activeTab" class="setting-tabs-items">
            <v-tab-item>
              <PinnedAccountOrganization v-if="activeTab == 0 && dialog" />
            </v-tab-item>
            <v-tab-item>
              <GroupAnalysisManagement v-if="activeTab == 1 && dialog" />
            </v-tab-item>
            <v-tab-item>
              <TopicGroup v-if="activeTab == 2 && dialog" />
            </v-tab-item>
          </v-tabs-items>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import PinnedAccountOrganization from './PinnedAccountOrganization/index.vue';
import GroupAnalysisManagement from './GroupAnalysisManagement/index.vue';
import TopicGroup from './TopicGroup/index.vue';

export default {
  name: 'SettingModal',
  components: {
    PinnedAccountOrganization: PinnedAccountOrganization,
    GroupAnalysisManagement: GroupAnalysisManagement,
    TopicGroup: TopicGroup,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeTab: 0,
      tabLoading: false,
      tabLoadingTimer: null,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  watch: {
    activeTab() {
      this.showTabLoader();
    },
    value(val) {
      if (val) {
        this.activeTab = 0;
        this.showTabLoader();
      }
    },
  },
  beforeDestroy() {
    if (this.tabLoadingTimer) {
      clearTimeout(this.tabLoadingTimer);
      this.tabLoadingTimer = null;
    }
  },
  methods: {
    showTabLoader() {
      this.tabLoading = true;
      if (this.tabLoadingTimer) {
        clearTimeout(this.tabLoadingTimer);
      }
      this.tabLoadingTimer = setTimeout(() => {
        this.tabLoading = false;
        this.tabLoadingTimer = null;
      }, 500);
    },
    close() {
      this.$emit('input', false);
    },
  },
};
</script>

<style scoped>
.setting-modal-card {
  border-radius: 20px;
  overflow: hidden;
}

.setting-modal-header {
  background: #FFFFFF;
  border-bottom: 1px solid #E2E8F0;
  padding: 16px 24px;
}

.setting-modal-body {
  background: #F8F7F4;
  padding: 0;
  overflow: hidden;
}

.setting-content {
  position: relative;
  height: 65vh;
  background: #F8F7F4;
}

.setting-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  height: 100%;
}

.setting-loader-text {
  color: #64748B;
  font-size: 14px;
  font-weight: 500;
}

.setting-tabs {
  background: #FFFFFF;
  border-bottom: 1px solid #E2E8F0;
}

.setting-tabs-items {
  background: #F8F7F4;
  height: 100%;
  overflow-y: auto;
}

.color-navy {
  color: #1E293B;
}
</style>
